import React from "react";
import { Link } from "react-router-dom";
import { 
  FaInstagram, 
  FaFacebookF, 
  FaTwitter, 
  FaLinkedinIn, 
  FaEnvelope, 
  FaPhoneAlt, 
  FaMapMarkerAlt 
} from "react-icons/fa";
import { FiCalendar, FiMapPin } from "react-icons/fi";
import "./footer.css";

const GlobalFooter = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        
        {/* Brand & Event Meta */}
        <div className="footer-brand">
          <Link to="/home" className="footer-logo-link">
            <img src="/logo.jpg" alt="Bizarre Bazaar" className="footer-logo" />
          </Link>
          <p className="brand-description">
            Bringing African creativity to life through curated festivals, live experiences, and family-friendly events across Nairobi and beyond.
          </p>

          {/* Nav-aligned Event Meta badge */}
          <div className="footer-event-meta">
            <div className="meta-row">
              <FiCalendar className="nav-icon" />
              <span>11th, 12th &amp; 13th Dec</span>
            </div>
            <div className="meta-row">
              <FiMapPin className="nav-icon" />
              <span>KSTVET, Off Gigiri Rd</span>
            </div>
          </div>
        </div>

        {/* Navigation Links */}
        <div className="footer-links">
          <h3 className="footer-heading">Quick Links</h3>
          <ul>
            <li><Link to="/home">HOME</Link></li>
            <li><Link to="/about">ABOUT US</Link></li>
            <li><Link to="/events">FESTIVALS</Link></li>
            <li><Link to="/gallery">GALLERY</Link></li>
            <li><Link to="/contact">CONTACT</Link></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-contact">
          <h3 className="footer-heading">Contact Us</h3>
          <p><FaPhoneAlt className="icon" /> 0701 395 902</p>
          <p><FaEnvelope className="icon" /> info@bizbazevents.com</p>
          <p><FaMapMarkerAlt className="icon" /> Office: Nairobi Garage, Karen</p>
          
          <div className="footer-cta-wrapper">
            <Link to="/contact" className="exhibit-link footer-exhibit-btn">
              EXHIBIT WITH US
            </Link>
          </div>
        </div>

        {/* Social Links */}
        <div className="footer-socials">
          <h3 className="footer-heading">Follow Us</h3>
          <p className="social-subtext">Stay updated on our latest festivals and bazaars.</p>
          <div className="social-icons">
            <a href="https://instagram.com/bizbazevents/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FaInstagram />
            </a>
            <a href="https://facebook.com/@bizbazevents/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <FaFacebookF />
            </a>
            <a href="https://twitter.com/bizbazevents" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
              <FaTwitter />
            </a>
            <a href="https://linkedin.com/company/bizbazevents" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FaLinkedinIn />
            </a>
          </div>
        </div>

      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} BizBaz Events. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default GlobalFooter;